import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
	return twMerge(clsx(inputs));
}

export const ANNOTATION_TYPE_HELPER = {
	appuntamento: { label: "Appuntamento" },
	backoffice: { label: "Backoffice" },
	relazione: { label: "Relazione" },
	telefonica: { label: "Telefonata" },
	email: { label: "E-mail" },
};

export const ANNOTATION_TYPE_HELPER_ARRAY = Object.keys(ANNOTATION_TYPE_HELPER).map((key) => ({
	label: ANNOTATION_TYPE_HELPER[key]?.label,
	value: key,
}));

export const TODO_TASKS_STATUS_AVAILABLE = {
	todo: {
		icon: "taskToWorkFilled",
		label: "Da lavorare",
		value: "todo",
	},
	waiting: {
		icon: "taskAwaitingFilled",
		label: "In attesa",
		value: "waiting",
	},
	in_progress: {
		icon: "taskInWorkingFilled",
		label: "In lavorazione",
		value: "in_progress",
	},
	done: {
		icon: "taskCompletedFilled",
		label: "Completata",
		value: "done",
	},
};

export const getTodoTdLink = ({ templatePlanId, organizationId }) => {
	return `${process.env.REACT_APP_HOST_CLIENT_TODO}/plans/${templatePlanId}/tasks${organizationId ? `?organizations=${organizationId}&scope=all` : ""}`;
};
